import { v4 as uuid } from 'uuid'

let sectionOrder = 0

class FormBuilderSection {
  constructor({ page, id, order, title, text }, isNew = true) {
    this.id = id ?? uuid()
    this.order = order ?? sectionOrder++
    this.page = page ?? uuid()
    this.text = text ?? ''
    this.title = title ?? ''
    this.isNew = isNew
  }
}

export default FormBuilderSection
